import {Modal as PeacockModal} from '@pepsico-ds/ui'

/**
 * @typedef {import('@pepsico-ds/ui').IModalProps} ModalProps
 * @property {boolean} [showModal] When true, shows the modal.
 * @property {boolean} [hideCloseButton] When true, hides the close button.
 * @property {() => void} [onCloseModal] Callback triggered when modal is closed.
 * @property {'fluid' | 'XL' | 'L' | 'M' | 'S'} [type] Modal size/type.
 * @property {'desktop' | 'mobile'} [viewPort] Modal viewport mode.
 * @property {string} [title] Modal title.
 * @property {string | import('react').ReactNode} [text] Modal description content.
 * @property {boolean} [showSlot] When true, renders slot content.
 * @property {boolean} [showTertiaryButton] When true, renders tertiary button.
 * @property {boolean} [showLink] When true, renders link action.
 * @property {boolean} [showSecondaryButton] When true, renders secondary button.
 * @property {boolean} [showPrimaryButton] When true, renders primary button.
 * @property {boolean} [showAuxiliaryButton] When true, renders auxiliary button.
 * @property {import('@pepsico-ds/ui').IButtonProps} [tertiaryButtonProps] Tertiary button props.
 * @property {import('@pepsico-ds/ui').ILinkProps} [linkProps] Link props.
 * @property {import('@pepsico-ds/ui').IButtonProps} [secondaryButtonProps] Secondary button props.
 * @property {import('@pepsico-ds/ui').IButtonProps} [primaryButtonProps] Primary button props.
 * @property {import('@pepsico-ds/ui').IButtonProps} [auxiliaryButtonProps] Auxiliary button props.
 * @property {boolean} [closeOnOutsideClick] When true, closes modal on outside click.
 * @property {import('@pepsico-ds/ui').IFooterProps} [footerProps] Footer configuration props.
 * @property {import('@pepsico-ds/ui').INotificationProps} [notificationsProps] Notification props.
 * @property {string} ['data-cy'] Optional Cypress test attribute.
 */

/**
 * Wrapper around Peacock DS Modal.
 * Supports all Peacock DS modal props.
 * @param {ModalProps} props
 */

export const Modal = props => {
  const defaultProps = {
    showLink: false,
    showAuxiliaryButton: false,
    showSecondaryButton: false,
  }

  return <PeacockModal {...defaultProps} {...props} />
}
